import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import { StopIcon } from '@10xLabs/react-web/components/Icons/Stop'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { StyledLink } from 'components/v2/Link'
import { Dropdown } from 'components/v2/Dropdown'
import List from 'components/v2/List'
import { isSuperAdmin } from 'features/Users/utils'
import { useLogin } from 'features/Login/hooks'
import { RouteNameForm } from 'features/Routes/views/Index/RoutesList/RouteNameForm'

const StyledTableContainer = styled(TableContainer)<TSFixMe>`
  overflow: auto;
`

const StopsWrapper = styled.div<TSFixMe>`
  display: flex;
  align-items: flex-start;

  > svg {
    margin-right: 8px;
  }
`

const StyledTh = styled(Th)<TSFixMe>`
  ${(props): TSFixMe => {
    if (props.isFirstElementActive) {
      return `
        border-bottom: none;
      `
    }
  }}
`

const StyledTr = styled(Tr)<TSFixMe>`
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.3);

  :nth-child(even) {
    background-color: rgba(230, 230, 230, 0.3);
  }

  ${(props): TSFixMe => {
    if (props.isActive) {
      return `
        background-color: #ecf4ff!important;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.19);
        border: solid 2px #8665d8;
      `
    }
  }}
`

const CompanyCell = styled(Td)<TSFixMe>`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 80px;
`

const SegmentCell = styled(Td)<TSFixMe>`
  white-space: nowrap;
`

export const RoutesList = ({ routes = [], activeRouteIndex, setActiveRouteIndex }: TSFixMe): TSFixMe => {
  const login = useLogin()
  const showCompany = isSuperAdmin(login.accessToken.conditions)

  return (
    <StyledTableContainer>
      <Table marginBottom>
        <Thead>
          <Tr>
            <StyledTh isFirstElementActive={activeRouteIndex === 0}>
              <FormattedMessage id="dictionary.route" defaultMessage="Route" />
            </StyledTh>
            <StyledTh isFirstElementActive={activeRouteIndex === 0}>
              <FormattedMessage id="dictionary.name" defaultMessage="Name" />
            </StyledTh>
            <StyledTh isFirstElementActive={activeRouteIndex === 0}>
              <FormattedMessage id="dictionary.stops" defaultMessage="Stops" />
            </StyledTh>
            {showCompany && (
              <StyledTh isFirstElementActive={activeRouteIndex === 0}>
                <FormattedMessage id="dictionary.company" defaultMessage="Company" />
              </StyledTh>
            )}

            <StyledTh isFirstElementActive={activeRouteIndex === 0}>
              <FormattedMessage id="dictionary.services" defaultMessage="Services" />
            </StyledTh>
          </Tr>
        </Thead>
        <Tbody>
          {routes.map((route: TSFixMe, index: TSFixMe): TSFixMe => {
            return (
              <StyledTr
                key={route.id}
                isActive={activeRouteIndex === index}
                onClick={(): TSFixMe => setActiveRouteIndex(index)}
              >
                <SegmentCell>
                  <StyledLink as={NavLink} to={`/routes/${route.id}`}>
                    {route.origin.code} - {route.destination.code}
                  </StyledLink>
                </SegmentCell>
                <Td>
                  <RouteNameForm routeId={route.id} routeName={route.name} />
                </Td>
                <Td>
                  <StopsWrapper>
                    <StopIcon />
                    {route.intermediateStops.length > 0 ? (
                      <Dropdown toggle={<StyledLink>{route.intermediateStops.length}</StyledLink>} noPadding>
                        <List.Container>
                          {route.intermediateStops.map((stop: TSFixMe): TSFixMe => {
                            return <List.Item key={stop.id}>{stop.name}</List.Item>
                          })}
                        </List.Container>
                      </Dropdown>
                    ) : (
                      0
                    )}
                  </StopsWrapper>
                </Td>
                {showCompany && <CompanyCell>{route.company.name}</CompanyCell>}
                <Td>{route.services.length}</Td>
              </StyledTr>
            )
          })}
        </Tbody>
      </Table>
    </StyledTableContainer>
  )
}
